module.exports = __webpack_public_path__ + "img/t6.1e401d97.png";